export default "__VITE_ASSET__D3UZnPB6__"